/**
 * Abstract visitor for subclasses of `AbstractFormulaToken`.
 */
export default class AbstractFormulaTokenVisitor {
	visit(token) {
		return token.accept(this);
	}

	visitAll(tokens) {
		return tokens.map((token) => this.visit(token));
	}

	visitAbstractFormulaToken(_token) {}

	visitAbstractValueFormulaToken(token) {
		return this.visitAbstractFormulaToken(token);
	}

	visitAccountFormulaToken(token) {
		return this.visitAbstractValueFormulaToken(token);
	}

	visitAccountIntervalFormulaToken(token) {
		return this.visitAbstractValueFormulaToken(token);
	}

	visitAccountGroupFormulaToken(token) {
		return this.visitAbstractValueFormulaToken(token);
	}

	visitConstantFormulaToken(token) {
		return this.visitAbstractValueFormulaToken(token);
	}

	visitKeyFigureFormulaToken(token) {
		return this.visitAbstractValueFormulaToken(token);
	}

	visitOpeningParenthesisFormulaToken(token) {
		return this.visitAbstractFormulaToken(token);
	}

	visitClosingParenthesisFormulaToken(token) {
		return this.visitAbstractFormulaToken(token);
	}

	visitAbstractBinaryOperatorFormulaToken(token) {
		return this.visitAbstractFormulaToken(token);
	}

	visitAdditionFormulaToken(token) {
		return this.visitAbstractBinaryOperatorFormulaToken(token);
	}

	visitSubtractionFormulaToken(token) {
		return this.visitAbstractBinaryOperatorFormulaToken(token);
	}

	visitMultiplicationFormulaToken(token) {
		return this.visitAbstractBinaryOperatorFormulaToken(token);
	}

	visitDivisionFormulaToken(token) {
		return this.visitAbstractBinaryOperatorFormulaToken(token);
	}
}
